<template>
<div style="margin-bottom:3rem">
  <v-dialog width="1000" v-model="show">
    <v-btn block color="primary" slot="activator">
      {{ $t('dir.new') }}
    </v-btn>
    <v-card>
      <v-card-title class="headline" primary-title>
        {{ $t('dir.new') }}
      </v-card-title>
      <v-container>
        <DirForm ref="formComponent" :schemas="schemas" v-on:saved="create($event)" />
      </v-container>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
import http from '@/plugins/http'
import DirForm from './DirForm'

export default {
  components: {
    DirForm
  },
  props: ["schemas"],
  data() {
    return {
      dirView: {},
      show: false
    }
  },
  methods: {
    create(dir) {
      http.post('dir-view', dir)
        .then((data) => {
          this.$emit("created", data.data)
          this.show = false;
          this.showMessage(this.$t('related.created'), "success")
          this.$refs.formComponent.resetForm()
        })
        .catch(() => this.showMessage(this.$t('related.cannot_create'), "danger"))
    },
    showMessage(text, color) {
      this.$store.commit("setSnack", {
        message: text,
        color: color,
      })
    }
  }
}
</script>
<style>
.loading-circle {
  margin: 20px;
}
</style>
